import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import Header from "@/components/Header";
import BottomBar from "@/components/BottomBar";
import cardStatusImage01 from "@/assets/images/help/card-status-change-01.png";
import cardStatusImage02 from "@/assets/images/help/card-status-change-02.png";

export default function HelpCardStatus() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header showBack={true} onBackClick={() => navigate("/help")} />

      <div className="max-w-md mx-auto px-4 pb-20">
        {/* Title */}
        <div className="mt-6 mb-9">
          <h1 className="text-[32px] font-bold leading-[1.6] opacity-80">
            Card Status Change Guide
          </h1>
        </div>

        {/* Content */}
        <div className="space-y-9">
          {/* Introduction */}
          <div className="space-y-4">
            <p className="text-base font-bold leading-[1.6] opacity-70">
              You can suspend your card temporarily when you need to stop its
              use.
              {"\n\n"}
              Suspended cards cannot be used for payments or top-ups and will
              remain inactive until you reactivate them.
            </p>
          </div>

          {/* Step 1 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 1: Suspend the Card</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              On the My Card screen, select the card you want to suspend and
              click the "Lock Card" button."
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={cardStatusImage01}
                alt="Card Status Change Step 1"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 2 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 2: Card Suspended</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70">
              The card will be suspended immediately, and payments or top-ups
              will be restricted. Suspended cards can be reactivated at any
              time.
            </p>
            <div className="rounded-[10px] overflow-hidden shadow-[0px_0px_4px_0px_rgba(0,0,0,0.25)]">
              <img
                src={cardStatusImage02}
                alt="Card Status Change Step 2"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Step 3 */}
          <div className="space-y-4">
            <h3 className="text-lg font-bold opacity-90">Step 3: Reactivate Your Card</h3>
            <p className="text-base font-bold leading-[1.6] opacity-70 whitespace-pre-line">
              Select the suspended card and click the "Lock Card" button.
              {"\n\n"}After completing security verification, your card will be
              reactivated.
              {"\n\n\n"}The card will be active immediately, and payment and
              top-up functions will be restored.
            </p>
          </div>
        </div>

        {/* Next Step */}
        <div className="mt-8">
          <Button
            onClick={() => navigate("/help/13")}
            className="w-full h-12 flex items-center justify-between"
          >
            <span>Next: Guide to Reporting a Stolen Card</span>
            <ChevronRight className="w-5 h-5" />
          </Button>
        </div>
      </div>

      <BottomBar />
    </div>
  );
}
